import React, { useState } from "react";

import UIButton from "../../ui-kit/button";
import Operator from "../../ui-kit/operator";

import "./HomeHeader.scss";
import "../../../pages/uiKit.scss";
import { translateString } from "../../../helpers/translator";

const HomeHeader = ({ language }) => {
  return (
    <>
      <header className="home-header">
        <section className="ui-kit-section">
          <div className="home-header__content">
            <div className="container">
              <div className="home-header__content-box row">
                <div className="home-header__text col-md-6">
                  <h3 className="section-title st">
                    {translateString("HOME.HEADER.weBuild", language)}
                  </h3>
                  <h1 className="home-header__title">
                    {translateString("HOME.HEADER.header_1", language)} <br />
                    <span className="nowrap">
                      <span>
                        {translateString("HOME.HEADER.header_2.1", language)}
                      </span>
                      <Operator>
                        {translateString("HOME.HEADER.header_2.2", language)}
                      </Operator>
                      {translateString("HOME.HEADER.header_2.3", language)}
                    </span>
                  </h1>
                  <p className="home-header__description">
                    {translateString("HOME.HEADER.description", language)}
                  </p>
                  <div className="home-header__actions d-flex gap-3">
                    <a href="#quote">
                      <UIButton
                        text={translateString(
                          "HOME.HEADER.getQuote",
                          language
                        )}
                        size="large"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </header>
    </>
  );
};

export default HomeHeader;
